module.exports = __webpack_public_path__ + "img/shakytubes_thumb.3a972a50.jpg";